var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanServices(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 35.4029C30 32.9016 31.5363 30.7304 33.7136 30.1399L38.8732 28.75L41.4762 33.7758C41.932 34.6525 43.068 34.6525 43.5238 33.7758L46.0759 28.848L51.2355 30.1734C53.4382 30.7407 55 32.9274 55 35.4493L54.8404 41.6639C54.8404 42.8165 54.0028 43.75 52.9685 43.75H31.9968C30.9625 43.75 30.1226 42.8165 30.1226 41.6639L30 35.4029Z",
    stroke: "#DB3725",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 38.8689C5 35.5371 7.1491 32.6369 10.2007 31.8544L17.4255 30L21.0669 36.6991C21.7036 37.8705 23.2942 37.8705 23.9309 36.6991L27.5053 30.1281L34.73 31.8995C37.8129 32.6535 40 35.5679 40 38.9305L39.7766 47.2184C39.7766 48.7527 38.6038 50 37.1539 50H7.79473C6.3471 50 5.17425 48.7527 5.17425 47.2184L5 38.8689Z",
    stroke: "#001823",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 17.5C30 21.6405 26.6427 25 22.4988 25C18.3597 25 15 21.6405 15 17.5C15 13.3573 18.3597 10 22.4988 10C26.6427 10 30 13.3573 30 17.5Z",
    stroke: "#001823"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 18.75C47.5 21.5106 45.2627 23.75 42.5 23.75C39.7373 23.75 37.5 21.5106 37.5 18.75C37.5 15.9894 39.7373 13.75 42.5 13.75C45.2627 13.75 47.5 15.9894 47.5 18.75Z",
    stroke: "#DB3725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanServices);
export default __webpack_public_path__ + "static/media/HumanServices.ff2f98b9ba76508ce6560fb78d23ec5b.svg";
export { ForwardRef as ReactComponent };